export const GET_GIFT_OPTIONS_SUCCESS = 'GET_GIFT_OPTIONS_SUCCESS';
export const REQUEST_GIFT_OPTIONS = 'REQUEST_GIFT_OPTIONS';
export const SET_GIFT_OPTIONS_SAVING = 'SET_GIFT_OPTIONS_SAVING';
export const TOGGLE_GIFT_OPTIONS = 'TOGGLE_GIFT_OPTIONS';
export const GIFT_OPTIONS_IMPRESSION = 'GIFT_OPTIONS_IMPRESSION';
export const GIFT_OPTIONS_NOT_ELIGIBLE = 'GIFT_OPTIONS_NOT_ELIGIBLE';
